import AvatarChip from './avatar-chip';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface ActingAsUserMessageProps {
  userEmail: string;
}

export default function ActingAsUserMessage({
  userEmail,
}: ActingAsUserMessageProps) {
  return (
    <Stack flexDirection="row" alignItems="center" gap={1} mb={2}>
      <Typography variant="caption">Acting as:</Typography>
      <AvatarChip email={userEmail} type="User" />
    </Stack>
  );
}
